module.exports = __webpack_public_path__ + "static/media/HomeRoll_Walls_CorrIronWall.901053e1.jpg";